import DisclosureLayoutProvider from './hooks/useDisclosureLayout';

import { DisclosureLayoutProps } from './@types/DisclosureLayoutProps';
// import { DisclosureLayout as LayoutVtex } from '@vtex/disclosure';

const DisclosureLayout = (props: DisclosureLayoutProps) => (
	<DisclosureLayoutProvider {...props}>
		{/* <LayoutVtex initialVisibility={props.initialVisibility} animated={props.animated}> */}
		{props.children}
		{/* </LayoutVtex> */}
	</DisclosureLayoutProvider>
);

export default DisclosureLayout;
